import React from 'react'
import logo from "../assets/logo.png"

// icons start 
import { FaFacebookF } from "react-icons/fa6";
import { BsTwitterX } from "react-icons/bs";
import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <div className='flex justify-center items-center'>
            <div className='flex w-[70vw] justify-between items-center px-[50px] pb-[8px]  fixed top-[10px] z-10'>
                <div>
                    <p>9718826488</p>
                </div>
                <div className='flex justify-between items-center gap-[20px]'>
                    <span><FaFacebookF /></span>
                    <span><BsTwitterX /></span>
                </div>
            </div>
            {/* header container start  */}
            <div className='flex w-[70vw] justify-between items-center px-[50px] py-[25px] bg-white  fixed top-[30px] rounded-3xl z-10'>
                <div className='header_left_container '>
                    <img src={logo} alt="logo" />
                </div>

                <div className='header_right_container'>
                    <ul className='flex gap-9 font-semibold items-center text-black text-[16px]' >
                        <li className='text-main-color '>Home</li>
                        <li>About</li>
                        <li>Gallery</li>
                        <li>Contact us</li>
                        {/* <li className='bg-main-color text-white px-[15px] py-[10px] rounded-full'>Get Quote</li> */}
                        <Link to="/login">
                        <li  className='bg-main-color text-white px-[15px] py-[10px] rounded-full'>Login</li>
                        </Link>
                    </ul>
                </div>
            </div>
            {/* header container end */}

        </div>
    )
}

export default Header